// Events
import { MOUNT } from 'events';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

// Utils
import choozy from 'utils/choozy';
import { desktopOnlyFunction, mobileOnlyFunction } from 'utils/device';
import { hide, show } from 'utils/node';

export default component((node, ctx) => {
  const { title, description, closeButton } = choozy(node);

  const PADDING = 50;

  const getButtonOffsets = (button) => {
    const { left, width, top, height } = button.getBoundingClientRect();

    return {
      width,
      height,
      left,
      top,
      right: window.innerWidth - (left + width),
      bottom: window.innerHeight - (top + height),
    };
  };

  const setModalPosition = desktopOnlyFunction((button) => {
    const { left, top, right, bottom } = getButtonOffsets(button);
    const { width, height } = node.getBoundingClientRect();

    if (width > right) {
      setCSSProperty(node, '--modal-left', 'auto');
      setCSSProperty(node, '--modal-right', `${Math.min(right, PADDING)}px`);
    } else {
      setCSSProperty(node, '--modal-left', `${left}px`);
      setCSSProperty(node, '--modal-right', `auto`);
    }

    if (height > bottom) {
      setCSSProperty(node, '--modal-bottom', `${Math.min(bottom, PADDING) - window.scrollY}px`);
      setCSSProperty(node, '--modal-top', 'auto');
    } else {
      setCSSProperty(node, '--modal-top', `${top + window.scrollY}px`);
      setCSSProperty(node, '--modal-bottom', 'auto');
    }
  });

  const close = () => {
    node.classList.remove('show');
    hide(node);
  };

  const open = (button) => {
    const { infoTitle, infoDescription } = button.dataset;

    title.textContent = infoTitle;
    description.textContent = infoDescription;

    show(node);
    setModalPosition(button);

    node.classList.add('show');
  };

  node.addEventListener('mouseleave', desktopOnlyFunction(close));
  closeButton.addEventListener('click', close);

  ctx.on(MOUNT, () => {
    const infoBoxButtons = [...document.querySelectorAll('[data-info-box-button]')];

    infoBoxButtons.forEach((button) => {
      button.removeAttribute('data-info-box-button');

      button.addEventListener(
        'click',
        mobileOnlyFunction(() => open(button)),
      );
      button.addEventListener(
        'mouseenter',
        desktopOnlyFunction(() => open(button)),
      );
    });
  });
});
